module.exports = __webpack_public_path__ + "img/Acorazon.a762540d.png";